import React from 'react';

export default function RefundCancellation() {
  return (
    <div style={{ paddingTop: '70px' }}>
      <div className="page-header">
        <h1>Refund &amp; Cancellation Policy</h1>
        <p>Your satisfaction is our priority</p>
      </div>
      <div className="container">
        <div className="policy-content">
          <h2>Introduction</h2>
          <p>At Saliheen Perfumes, we strive to ensure your complete satisfaction with every purchase. Please read our Refund &amp; Cancellation Policy carefully to understand your rights and responsibilities.</p>

          <h2>No Cancellations After Ordering</h2>
          <p>Once an order is placed, it <strong>cannot be cancelled</strong>. Please review your order carefully before completing the purchase.</p>

          <h2>Refund Policy</h2>
          <h3>Damaged or Defective Items</h3>
          <p>If you receive a damaged or defective item, you are eligible for a full refund, provided the item is returned within <strong>7 days</strong> of the order date.</p>

          <h3>Non-Damaged Items</h3>
          <p>Refunds are <strong>not available</strong> for non-damaged items or items returned after 7 days.</p>

          <h2>Refund Process</h2>
          <ol>
            <li>Contact our support team at <a href="mailto:saliheenperfumes@gmail.com">saliheenperfumes@gmail.com</a> within 7 days of receiving the damaged item.</li>
            <li>Provide your order number, photos of the damaged item, and a brief description of the issue.</li>
            <li>Once your request is approved, you will receive instructions on how to return the item.</li>
            <li>After we receive and inspect the returned item, your refund will be processed within <strong>5-7 business days</strong>.</li>
          </ol>

          <h2>Contact Us</h2>
          <p>If you have any questions about our Refund &amp; Cancellation Policy, please contact us at <a href="mailto:saliheenperfumes@gmail.com">saliheenperfumes@gmail.com</a></p>
        </div>
      </div>
    </div>
  );
}
